import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import type { ReactNode } from "react";

export interface SidebarItem {
  key: string;
  label: ReactNode;
  icon?: ReactNode;
  selected?: boolean;
  onSelect: () => void;
}

export interface SidebarProps {
  items: SidebarItem[];
  open?: boolean;
  onClose?: () => void;
  variant?: "permanent" | "temporary";
  width?: number;
}

/** Presentational nav drawer — the host app supplies items and a selection/navigation callback. */
export function Sidebar({
  items,
  open = true,
  onClose,
  variant = "permanent",
  width = 240,
}: SidebarProps) {
  return (
    <Drawer
      variant={variant}
      open={open}
      onClose={onClose}
      sx={{
        width: variant === "permanent" ? width : undefined,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width, boxSizing: "border-box" },
      }}
    >
      <Toolbar />
      <List>
        {items.map((item) => (
          <ListItemButton key={item.key} selected={item.selected} onClick={item.onSelect}>
            {item.icon ? <ListItemIcon>{item.icon}</ListItemIcon> : null}
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
    </Drawer>
  );
}
